module.exports = __webpack_public_path__ + "static/img/Round-16-2013.c7f385e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-16-2013.jpg
// module id = L3DD
// module chunks = 0